import type { WorkItemEnhanced } from "../../types/cqa";
import { WorkItemDataEntry } from "../../types/sd";
import { getCqaGraderWorkitemsBatch } from "../api";

export async function cqaTransformWorkItems(workItems: WorkItemDataEntry[]): Promise<WorkItemEnhanced[]> {
    if(workItems.length == 0){
        return [];
    }

    const sdCaseIds = workItems.map((wi) => wi.data.case_id);
    const cqaGraderWorkItems = await getCqaGraderWorkitemsBatch(sdCaseIds);

    return workItems.map(workitem => {
        const grader = cqaGraderWorkItems.find((g) => g.sdCaseId === workitem.data.case_id);
        return {
            ...workitem,
            data: {
                ...workitem.data,
                cqa_invoices: grader?.invoices || [],
                cqaWorkItemId: grader?.workItem?.id,
            },
        };
    });
}

/**
 * Combine CQA-transformed (enriched) work items with unassigned CQA work items.
 *
 * The unassigned items do not get the CQA transform applied. An unassigned item
 * whose case_id already appears in the transformed set is dropped so it is not
 * shown twice; the transformed (enriched) copy wins.
 */
export function mergeCqaWorkItems(
    transformedItems: WorkItemEnhanced[],
    unassignedItems: WorkItemDataEntry[]
): Array<WorkItemEnhanced | WorkItemDataEntry> {
    const seenCaseIds = new Set(transformedItems.map((wi) => wi.data.case_id));
    return [
        ...transformedItems,
        ...unassignedItems.filter((wi) => !seenCaseIds.has(wi.data.case_id)),
    ];
}